// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Trippy Theme Styles */
@keyframes trippy-bg {
  0% { filter: hue-rotate(0deg); }
  100% { filter: hue-rotate(360deg); }
}

@keyframes catnip-float {
  0% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-5px) rotate(1deg); }
  100% { transform: translateY(0px) rotate(0deg); }
}

.theme-trippy {
  animation: trippy-bg 30s linear infinite;
}

.theme-trippy .MuiPaper-root, 
.theme-trippy .MuiCard-root {
  animation: catnip-float 6s ease-in-out infinite;
  backdrop-filter: blur(10px);
}

.theme-trippy h1, 
.theme-trippy h2, 
.theme-trippy h3 {
  text-shadow: 0 0 10px rgba(0, 255, 204, 0.5);
}

/* Pure Black Theme Styles */
.theme-black .MuiPaper-root {
  border: 1px solid #222 !important;
}

.theme-black body {
  background-color: #000 !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,wBAAwB;AACxB;EACE,KAAK,wBAAwB,EAAE;EAC/B,OAAO,0BAA0B,EAAE;AACrC;;AAEA;EACE,KAAK,uCAAuC,EAAE;EAC9C,MAAM,wCAAwC,EAAE;EAChD,OAAO,uCAAuC,EAAE;AAClD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA,4BAA4B;AAC5B;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Trippy Theme Styles */\n@keyframes trippy-bg {\n  0% { filter: hue-rotate(0deg); }\n  100% { filter: hue-rotate(360deg); }\n}\n\n@keyframes catnip-float {\n  0% { transform: translateY(0px) rotate(0deg); }\n  50% { transform: translateY(-5px) rotate(1deg); }\n  100% { transform: translateY(0px) rotate(0deg); }\n}\n\n.theme-trippy {\n  animation: trippy-bg 30s linear infinite;\n}\n\n.theme-trippy .MuiPaper-root, \n.theme-trippy .MuiCard-root {\n  animation: catnip-float 6s ease-in-out infinite;\n  backdrop-filter: blur(10px);\n}\n\n.theme-trippy h1, \n.theme-trippy h2, \n.theme-trippy h3 {\n  text-shadow: 0 0 10px rgba(0, 255, 204, 0.5);\n}\n\n/* Pure Black Theme Styles */\n.theme-black .MuiPaper-root {\n  border: 1px solid #222 !important;\n}\n\n.theme-black body {\n  background-color: #000 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
